var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.externalScript)?_c('CookieInformationBlockerCustom',{class:[
		'c-block-list-external-script-custom',
		{
			revert: _vm.revertExternalStyles,
		},
	],attrs:{"id":_vm.$vnode.key,"categories":_vm.computedCookies}},[_c('PostscribeScript',{staticClass:"w-full",attrs:{"html":_vm.externalScript,"lazyload":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }